import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OptionHiglightModule } from '../../../shared/directives/option-higlight/option-higlight.module';
import { SharedModule } from '../../../shared/shared.module';
import { StoreAuthorityScopeListComponent } from './store-authority-scope-list/store-authority-scope-list.component';
import { StoreAuthorityStoreListComponent } from './store-authority-store-list/store-authority-store-list.component';
import { StoreAuthorityViewerComponent } from './store-authority-viewer/store-authority-viewer.component';

@NgModule({
  declarations: [StoreAuthorityScopeListComponent, StoreAuthorityStoreListComponent, StoreAuthorityViewerComponent],
  imports: [CommonModule, OptionHiglightModule, SharedModule],
  exports: [StoreAuthorityScopeListComponent, StoreAuthorityStoreListComponent, StoreAuthorityViewerComponent]
})
export class StoreAuthorityComponentsModule {}
